var _circle, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 77,
    viewBox: "0 0 96 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38.2559,
    r: 24,
    fill: "#EF183E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27060_4810)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.8898,
    cy: 38.2551,
    r: 34.2551,
    fill: "#FCFDFC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27060_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6187 50.984L44.1627 25.528M69.6187 50.984C72.9944 47.6083 74.8908 43.0299 74.8908 38.256C74.8908 33.482 72.9944 28.9036 69.6187 25.528C66.2431 22.1523 61.6647 20.2559 56.8907 20.2559C52.1168 20.2559 47.5384 22.1523 44.1627 25.528L69.6187 50.984ZM69.6187 50.984C66.2431 54.3596 61.6647 56.2561 56.8907 56.2561C52.1168 56.2561 47.5384 54.3596 44.1627 50.984C40.7871 47.6083 38.8906 43.0299 38.8906 38.256C38.8906 33.482 40.7871 28.9036 44.1627 25.528L69.6187 50.984Z",
    stroke: "#001234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27060_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1255 29.3809H39.125L15.125 53.3804L15.1255 29.3809Z",
    fill: "#001234"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27060_4810",
    x: 18.6348,
    y: 0,
    width: 76.5098,
    height: 76.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4810"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27060_4810",
    x: 11.125,
    y: 25.3809,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27060_4810"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27060_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(32.8906 14.2559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.61cc9fdd99e69dd16b83c91d0589c301.svg";
export { ForwardRef as ReactComponent };